export * from "./FilterPage/FilterPage"
export * from "./SectionPage/SectionPage"
export * from "./FlatPage/FlatPage"
export * from "./FloorPage/FloorPage"


// WEBPACK FOOTER //
// ./js/pages/index.js